import { useEffect, useState } from "react";
import { isIOS } from "react-device-detect";
import { Link } from "react-router";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import {
  ANDROID_APP_LINK,
  IOS_APP_LINK,
} from "@components/Footer/utils/constant";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import Modal from "@components/Modal/Modal";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { SCREEN_SM } from "@util/constant";
import Cookies from "js-cookie";

export default function AppBanner(): React.ReactElement {
  const sendDataToGTM = useGTMDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onClose = () => {
    setIsModalOpen(false);
    sendDataToGTM({
      event: "custom_event",
      eventCategory: "bottom sheet",
      eventAction: "click",
      eventLabel: "continue in mobile web",
      nonInteraction: false,
    });
  };
  const onLinkClick = () => {
    sendDataToGTM({
      event: "custom_event",
      eventCategory: "bottom sheet",
      eventAction: "click",
      eventLabel: "open the app",
      nonInteraction: false,
    });
  };

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.innerWidth === 0) return;
    if (window.innerWidth > SCREEN_SM) return;

    const cookie = Cookies.get("BT-APP-BANNER");

    if (typeof cookie !== "undefined") return;
    if (cookie === "displayed") return;

    setIsModalOpen(true);

    Cookies.set("BT-APP-BANNER", "displayed");

    sendDataToGTM({
      event: "custom_event",
      eventCategory: "bottom sheet",
      eventAction: "visible",
      eventLabel: window.location.href,
      nonInteraction: false,
    });
  }, [sendDataToGTM]);

  return (
    <Modal
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      dialogPanelClassNames="absolute left-0 right-0 bottom-0"
    >
      <div className="flex items-center justify-between p-3">
        <ButtonFactory
          buttonType={ButtonType.Secondary}
          className="rounded-full bg-gray-250 p-4 hover:border-gray-250"
          onClick={onClose}
          icon={<IconFactory type={IconTypeEnum.close} />}
        />

        <h3 className="text-center font-poppins text-base font-semibold text-gray-850">
          Open in the BT App
        </h3>

        <Link
          to={isIOS ? IOS_APP_LINK : ANDROID_APP_LINK}
          target="blank"
          rel="noopener noreferer"
          className="block rounded-full bg-gray-850 px-6 pb-5 pt-4 font-poppins text-xs font-semibold text-white"
          onClick={onLinkClick}
        >
          Open
        </Link>
      </div>
    </Modal>
  );
}
